import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductTransferOwnershipDocument.Order.IRequest;
type Response = Api.Core.ProductTransferOwnershipDocument.Order.IResponse;
type Headers = Api.Core.ProductTransferOwnershipDocument.Order.IHeaders;
const url = '/api/ProductManagement/ProductTransferOwnershipDocument/DocumentOrder';
export default async function productTransferOwnershipDocumentOrderApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
